<template>
    <v-autocomplete
            :label="(label)? label : 'Búsqueda de item'"
            :items="items"
            :value="value"
            item-text="B1_DESC"
            item-value="B1_COD"
            clearable
            hide-no-data
            :search-input.sync="search"
            @input="actualizaValor($event)"
            :loading="loading"
            return-object
            :error-messages="errores.collect('item')"
            v-validate="validate"
            data-vv-name="item"
            @blur="$emit('blur')"
            @change="change($event)"
            :filter="filtro"
    >
        <template slot="item" slot-scope="data">
            <v-list-tile-content>
                <v-list-tile-title>{{ data.item.B1_DESC}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    UM: {{ data.item.B1_UM }}
                    Ancho: {{ data.item.B1_ANCHO }} |
                </v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</template>
<script>
    import mixinItem from '../mixins/items';

    export default {
        inject: ['$validator'],
        name: 'micro-item-select',
        props: ['label', 'value', 'tipo', 'preset', 'validate', 'empresa'],
        mixins: [mixinItem],
        data() {
            return {
                search: '',
                loading: false,
                listado: [],
            }
        },
        computed: {
            items() {
                return (this.preset) ? ((this.preset && Object.keys(this.preset).length !== 0) ? [this.preset] : []) : this.listado;
            }
        },
        watch: {
            search(val) {
                if (!val) {
                    return false;
                }
                let valor = (this.value && typeof this.value === 'object' && this.value.B1_COD) ? this.value.B1_COD : '';
                val && val !== valor && this.query(val)
            },
        },
        methods: {
            filtro(item, queryText, itemText) {
                const hasValue = val => val != null ? val : '';
                const text = hasValue(item.B1_COD + '-' + item.B1_DESC);
                const query = hasValue(queryText);
                let filt = text.toString()
                    .toLowerCase()
                    .indexOf(query.toString().toLowerCase()) > -1
                console.log(filt)
                return filt;
            },
            query(val) {
                this.loading = true;
                this.itemMicroSearch({
                    q: val,
                    empresa_id: this.empresa
                }, r => {
                    this.listado = r;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            actualizaValor(valor) {
                this.$emit('update:id', (valor) ? valor.B1_COD : '');
                this.$emit('input', (valor) ? valor : '');
            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MicroItemSelect.vue